import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Input, Select } from "antd";
import { API_URLS } from "../../../api/apiUrls";
import { getApi, putApi } from "../../../api/api_instance";
// import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../components/Elements/DailogBox/AcceptDialog";

const EditUsersDialog = ({
  onOpen,
  onClose,
  userData,
  onUpdate,
  onSave,
  onSuccessFalse,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [user, setUser] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [showAcceptDialog, setShowAcceptDialog] = useState(false);

  const [errorMessage, setErrorMessage] = useState({
    name: "",
    email: "",
    role: "",
  });

  useEffect(() => {
    if (userData) {
      setName(userData.name || "");
      setEmail(userData.email || "");
      setUser(userData.user || "");
    }
  }, [userData]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await getApi({ apiUrl: API_URLS.ALL_ROLES });
      if (response.success && response.data?.docs?.length > 0) {
        const formatted = response.data.docs.map((item) => ({
          label: item.Role,
          value: item._id,
        }));
        setRoleOptions(formatted);
      } else {
        console.error("Failed to fetch roles.");
      }
    } catch (error) {
      console.error("Error fetching roles.");
    }
  };

  const handleSave = async () => {
    let isValid = true;
    const errors = { name: "", email: "", role: "" };

    if (!name) {
      errors.name = "Name is required";
      isValid = false;
    }
    if (!email) {
      errors.email = "Email is required";
      isValid = false;
    }
   
    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);
    try {
      const response = await putApi({
        apiUrl: API_URLS.EDIT_USER(userData._id),
        data: { name, email, user},
      });

      if (response.success) {
        // toast.success("User updated successfully!");
        // setShowAcceptDialog(true);
        onSave();
        if (onUpdate) onUpdate();
        onClose();
      } else {
        onSuccessFalse(response.message);
        onClose();
      }
    } catch (error) {
      onSuccessFalse(error.message);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="600px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">Edit User</h3>
        </div>
        <div className="rounded-xl border mt-8 px-12">
          <div className="mt-3 mb-4">
            <hr />
          </div>
          <div className="flex flex-col gap-6">
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
              className="h-14 rounded-lg"
            />
            {errorMessage.name && (
              <div className="text-red-500 text-sm">{errorMessage.name}</div>
            )}

            <Input
              value={email}
              onChange={(e) => setUser(e.target.value)}
              placeholder="User"
              className="h-14 rounded-lg"
            />
            {errorMessage.email && (
              <div className="text-red-500 text-sm">{errorMessage.User}</div>
            )}

             
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="h-14 rounded-lg"
            />
            {errorMessage.email && (
              <div className="text-red-500 text-sm">{errorMessage.email}</div>
            )}
          </div>
          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={onClose}
              className="text-base font-normal h-[50px] w-[160px]"
            />
            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
              loading={loading}
            />
          </div>
        </div>
      </DailogBox>
      {/* 
      {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={() => {
            setShowAcceptDialog(false);
            onClose();
          }}
          heading="User Updated"
          subheading="The user details have been successfully updated."
          success={true}
        />
      )} */}
    </>
  );
};

export default EditUsersDialog;
